import { combineReducers } from "redux";
import { terrainSlice } from "./terrain";
import { mapSlice } from "./map";
import { userSlice } from "./user";
import { uploadSlice } from "./upload-file";
import { tableSlice } from "./table";
import { citiesSlice } from "./cities";
import {companiesSlice} from "./companies";
import { productsSlice } from "./products";
import {filtersSlice} from "./filters";
import {multiplePlotListSlice} from "./multiple-plot";
import { masterPlanModificationSlice } from "./master-plan-modification";
import {reportsJournalSlice} from "./reports-journal";
import {studyCreationSlice} from "./master-create-study";
import {masterUtilitiesSlice} from "./utilities-journal";

export const reducer = combineReducers({
    [terrainSlice.reducerPath]: terrainSlice.reducer,
    [mapSlice.reducerPath]: mapSlice.reducer,
    [userSlice.reducerPath]: userSlice.reducer,
    [uploadSlice.reducerPath]: uploadSlice.reducer,
    [tableSlice.reducerPath]: tableSlice.reducer,
    [citiesSlice.reducerPath]: citiesSlice.reducer,
    [companiesSlice.reducerPath]: companiesSlice.reducer,
    [productsSlice.reducerPath]: productsSlice.reducer,
    [filtersSlice.reducerPath]: filtersSlice.reducer,
    [multiplePlotListSlice.reducerPath]: multiplePlotListSlice.reducer,
    [masterPlanModificationSlice.reducerPath]: masterPlanModificationSlice.reducer,
    [reportsJournalSlice.reducerPath]: reportsJournalSlice.reducer,
    [studyCreationSlice.reducerPath]: studyCreationSlice.reducer,
    [masterUtilitiesSlice.reducerPath]: masterUtilitiesSlice.reducer,
});